import React from 'react'
import Button from 'components/button'
import { COMMON, LINK } from 'utils/intl/common'

function CardQoveryStarted(props) {
  const { className = '', title = COMMON.TITLE_STARTED, description = COMMON.DESCRIPTION_STARTED } = props

  return (
    <div className={`card-q-started ${className}`}>
      <div className="card-q-started__content">
        <h2 className="h1 c-white mb-4">{title.length === 0 ? COMMON.TITLE_STARTED : title}</h2>
        <p className="c-gray-6 mb-4">{description.length === 0 ? COMMON.DESCRIPTION_STARTED : description}</p>
        <Button className="btn" url={LINK.QOVERY_CONSOLE}>
          {COMMON.DEPLOY_MY_APPS}
        </Button>
      </div>
      <div className="card-q-started__image">
        <img src="../../images/img-started-in-seconds.svg" alt={COMMON.TITLE_STARTED} />
      </div>
    </div>
  )
}

export default CardQoveryStarted
